<template>
    <section id="about" class="about">
        <h2>{{$t('about.title')}}</h2>
        <div class="container">
            <div class="items">
                <div class="col" v-for="item in items">
                    <div class="item" :class="{ 'flipped': item.flipped }" @click="flip(item)">
                        <div class="inner">
                            <div class="front">
                                <div class="pic"><div class="image"><limg :src="item.src" alt="" /></div></div>
                                <div class="title">{{$t(item.title)}}</div>
                            </div>
                            <div class="back">
                                <div class="text">{{$t(item.text)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'About',
        data() {
            return {
                items: [
                    { title: 'about.installation.title', text: 'about.installation.text', src:'/assets/about/1.png' },
                    { title: 'about.quality.title', text: 'about.quality.text', src: '/assets/about/2.png' },
                    { title: 'about.investment.title', text: 'about.investment.text', src: '/assets/about/3.png' },
                    { title: 'about.support.title', text: 'about.support.text', src: '/assets/about/4.png' },
                    { title: 'about.safety.title', text: 'about.safety.text', src: '/assets/about/5.png' },
                    { title: 'about.account.title', text: 'about.account.text', src: '/assets/about/6.png' },
                    { title: 'about.multicurrency.title', text: 'about.multicurrency.text', src: '/assets/about/7.png' },
                    { title: 'about.adaptation.title', text: 'about.adaptation.text', src: '/assets/about/8.png' },
                    { title: 'about.individual.title', text: 'about.individual.text', src: '/assets/about/9.png' }
                ]
            }
        },
        methods: {
            flip(i) {
                this.items = this.items.map((item) => {
                    if (item == i) item.flipped = !item.flipped;
                    return item;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .about {
        background: $primary;
        color: $white;
        padding-top: 4*$spacer;
        padding-bottom: 4*$spacer;
    }

    h2 {
        font-size: 6rem;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        margin: 0;
        padding: 4*$spacer $spacer;
        color: $white;
    }

    .items {
        display: flex;
        align-items: stretch;
        padding: $spacer 0;
        margin-left: -$spacer;
        margin-right: -$spacer;
        flex-wrap: wrap;

        .col {
            flex: 0 0 auto;
            width: 33.33%;
            padding: $spacer;
        }
    }

    .item {
        position: relative;
        display: block;
        width: 100%;

        .inner {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            height: 100%;
            perspective: 1000px;
        }

        .front, .back {
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transition: 0.6s;
            transition: 0.6s;
            -webkit-transform-style: preserve-3d;
            transform-style: preserve-3d;
        }

        .front {
            position: relative;
            z-index: 1;
            display: flex;
            flex-direction: column;
            height: 100%;
            background: $white;
            -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
        }

        .back {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background: $grey-dark;
            -webkit-transform: rotateY(-180deg);
            transform: rotateY(-180deg);
        }

        .pic {
            background: $white;
            padding: $spacer;
            text-align: center;

            img {
                display: inline-block;
                max-width: 100%;
            }

            .image {
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 250px;
            }
        }

        .title {
            position: relative;
            width: 100%;
            flex: 1 1 auto;
            font-size: 1.8rem;
            color: $white;
            text-transform: uppercase;
            text-align: center;
            margin: 0;
            padding: $spacer;
            background: rgba($black, 0.7);

            .button {
                margin-top: $spacer;
            }
        }

        .text {
            position: relative;
            padding: $spacer;
            height: 100%;
            font-size: 1.6rem;
            color: $white;
            overflow: auto;
        }

        @media (max-width: ($desktop)-1) {
            &.flipped {
                .front {
                    -webkit-transform: rotateY(180deg);
                    transform: rotateY(180deg);
                }

                .back {
                    -webkit-transform: rotateY(0deg);
                    transform: rotateY(0deg);
                    z-index: 2;
                }
            }
        }

        @media (min-width: $desktop) {
            &:hover {
                .front {
                    -webkit-transform: rotateY(180deg);
                    transform: rotateY(180deg);
                }

                .back {
                    -webkit-transform: rotateY(0deg);
                    transform: rotateY(0deg);
                    z-index: 2;
                }
            }
        }
       
        @media (max-width: ($tablet)-1) {
            .inner {
                height: auto;
                background: $grey-dark;
            }

            .front {
                flex-direction: row;
                -webkit-transform: none;
                transform: none;

                .pic {
                    padding: 0;

                    .image {
                        width: 144px;
                        height: 100px;
                        min-height: 100px;

                        .limage {
                            height: 100%;
                            width: auto;
                        }
                    }
                }

                .title {
                    position: relative;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 2.8rem;
                    text-align: left;
                }
            }

            .back {
                position: relative;
                height: auto;
                max-height: 0;
                -webkit-transform: none;
                transform: none;
                transition: all 0.3s linear;
                overflow: hidden;

                .text {
                    font-size: 2.8rem;
                    overflow: auto;
                }
            }

            &.flipped {
                .front,
                .back {
                    -webkit-transform: none;
                    transform: none;
                }

                .back {
                    max-height: 100vh;
                }
            }
        }
    }

    @media (max-width: ($tablet)-1) {
        .items {
            display: block;

            .col {
                width: 100%;
            }
        }
    }

</style>
